import { TEXTOS } from '../../../lib/glossario'
import type { DetalheGmud } from '../../../types/gmud'
import { RessalvaDeHistorico } from './RessalvaDeHistorico'

/**
 * A capa: faixa laranja, o logotipo da Secretaria e o título alinhado à direita.
 *
 * O logotipo é o mesmo arquivo do sistema anterior (`public/img/logo_sexec_3.jpeg`, aqui
 * `public/img/logo-sexec.jpeg`), servido do próprio domínio. O documento antigo o embutia em
 * base64 porque o dompdf gera o PDF no servidor; aqui quem imprime é o navegador de quem
 * está logado, e um `<img>` normal basta — a aplicação roda atrás de CSP estrita, então o
 * arquivo tem de ser local de qualquer forma.
 *
 * O `alt` descreve a instituição, e não "logo": quem ouve a página quer saber de quem é o
 * documento.
 *
 * @param props a solicitação impressa
 * @returns o conteúdo da folha 1
 */
export function CapaDoRelatorio({ gmud }: { gmud: DetalheGmud }) {
  return (
    <>
      <div className="rdm-barra" />
      <img
        className="rdm-logo"
        src="/img/logo-sexec.jpeg"
        alt="Prefeitura Municipal de Niterói — Secretaria Executiva"
      />

      <div className="rdm-capa-titulo">
        <h1 className="rdm-titulo">
          Secretaria Executiva – SEXEC
          <br />
          Requisição de Mudança Sistema - {gmud.sistema?.trim() || TEXTOS.naoInformado}
          <br />
          (Ticket: {gmud.chamadoNumero?.trim() || TEXTOS.naoInformado})
        </h1>
      </div>

      {gmud.origem === 'MIGRADO_V1' && <RessalvaDeHistorico gmud={gmud} />}
    </>
  )
}
